"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var create_chainable_type_checker_1 = require("./utils/create-chainable-type-checker");
function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = typeof propValue;
    if (React.isValidElement(propValue)) {
        return new Error("Invalid " + location + " `" + propFullName + "` of type ReactElement " +
            ("supplied to `" + componentName + "`, expected an element type (a string ") +
            'or a ReactClass).');
    }
    if (propType !== 'function' && propType !== 'string') {
        return new Error("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " +
            ("supplied to `" + componentName + "`, expected an element type (a string ") +
            'or a ReactClass).');
    }
    return null;
}
exports.elementType = create_chainable_type_checker_1.createChainableTypeChecker(validate);



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-prop-types/element-type.js
// module id = 473
// module chunks = 0 1 2 3 4 5 6